import React, { FunctionComponent, useState } from "react";

import { LOC_CANCEL, LOC_CHOOSE_SET_TO_DUPLICATE_TO, LOC_NO_SETS_MESSAGE } from "../../../../locKeys";
import { IActivity, ISet } from "../../../../types";
import { UiWorkflow } from "../../../../UiWorkflow";
import { BasicDialog } from "../../BasicDialog";
import { BasicDialogItem } from "../../components";

export type DuplicateActivityDialogComponentProps = {
    readonly activeSetId: string;
    readonly selectedActivities: readonly IActivity[];
    readonly existingsSets: readonly ISet[];
    readonly uiWorkflow: UiWorkflow;
    readonly updateWorkflowView: (setId: string, selectedActivityId?: string, selectedTransitionId?: string) => void;
    readonly onCancelClick: () => void;
    readonly duplicateText: string;
};

export const DuplicateActivityDialogComponent: FunctionComponent<DuplicateActivityDialogComponentProps> = ({
    activeSetId,
    selectedActivities,
    existingsSets,
    uiWorkflow,
    updateWorkflowView,
    onCancelClick,
    duplicateText,
}) => {
    const [selectedSetId, setSelectedSetId] = useState<string>(activeSetId);

    const handleDuplicateClick = () => {
        if (selectedActivities) {
            const selectedActivitiesIds = selectedActivities.map(act => act.id);
            const newDuplicatedActivityId = uiWorkflow.workflow.duplicateActivities(selectedActivitiesIds, selectedSetId, activeSetId);
            updateWorkflowView(selectedSetId, newDuplicatedActivityId);
        }
    };

    const handleOnSaveClick = () => {
        if (selectedSetId !== undefined)
            handleDuplicateClick();
    };

    return (
        <BasicDialog
            cancelTextLocKey={LOC_CANCEL}
            headerLocKey={LOC_CHOOSE_SET_TO_DUPLICATE_TO}
            noItemsLocKey={LOC_NO_SETS_MESSAGE}
            buttonDisabled={selectedSetId === ""}
            onCloseChange={onCancelClick}
            onConfirmClick={handleOnSaveClick}
            confirmationButtonText={duplicateText}>
            {existingsSets.map(({ name, id }) =>
                <BasicDialogItem
                    key={id}
                    isSelected={id === selectedSetId}
                    onItemClick={() => setSelectedSetId(id)}
                    {...{ name }} />,
            )}
        </BasicDialog>
    );
};
